// extracted by mini-css-extract-plugin
export default {"__matchingConfigParam__":"_3q9iCO_125aiGh-KCR2Zgu","matchingConfigParam":"_3q9iCO_125aiGh-KCR2Zgu","tableText":"pTCeOyLlrqwQyr9OG6X5X"};